export default function makeDefaultBrowserPolicy(forbiddenCategories) {
    return {
        name: '',
        enabled: false,
        dataLossPrevention: {
            defaults: {
                allInput: false,
                clipboardPaste: false,
                pasteLimitEnabled: false,
                pasteLimit: -1,
            },
            domains: [],
        },
        contentFiltering: {
            filterContent: true,
            forbiddenCategories,
            webFilterList: {
                blacklistRules: [],
                whitelistRules: [],
            },
            whitelistThreatSim: true,
        },
        filterByURL: {
            allowed: [],
            blocked: [],
        },
        accessCodes: [],
        activationsAllowed: 0,
        printEnabled: true,
        clearCookiesEnabled: true,
        feedbackEnabled: true,
        faqEnabled: true,
        invitesEnabled: false,
        adBlockSwitchEnabled: true,
        blockAdsByDefault: true,
        settingsResearchMode: false,
        settingsBrowserLocation: false,
        hashEmail: true,
        checkUnsafe: true,
        homePageNotWelcome: false,
        useAccessCodes: true,
        emailRegistrationDisabled: false,
        tsaScan: true,
    };
}
